// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lN","controlPlay":"lO","controlElement":"lP","lowerControlWrapper":"lQ","lowerControlIconWrapper":"lR","lowerControlIcon":"lS","show":"lT"};